import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { cloneDeep } from "lodash";
import openAdStyle from "./open-show-style.vue";
import { IPSService } from "@/services/ipsServices";
import ShopDisplayEdit from "@/views/components/shopDisplaySketchMap/displayEdit";
import AppHoverIconDisplay from "@/views/components/shopDisplaySketchMap/appHoverIconDisplay.vue";
import { defaultImg } from "@/views/components/newDisplayConfig/shop";
export const ZhanKai = "https://ssl-picture.tenyun.runsasoft.com/zhankai.svg";
export const ShouQi = "https://ssl-picture.tenyun.runsasoft.com/shouqi.svg";

interface HoverIconInfo {
	siteId?: number;
	showType: 7;
	ygswpId?: number;
	fieldType?: string;
	desc?: HoverIconDesc;
}

interface HoverIconDesc {
	isEnable?: number;
	showBeforeIcon?: string;
	showAfterIcon?: string;
	list?: HoverIconLinkList;
}

interface HoverIconLinkList {
	iconImage?: string;
	iconName?: string;
	linkType?: number;
	linkId?: number;
	couponInfo?: { cplId?: string; couponCover?: string; points?: number };
	jumpPath?: { appName?: string; pagePath?: string };
	officialAccount?: {
		accountTitle?: string;
		accountUrl?: string;
	};
	linkDesc?: string;
	isAloneConfig: 0 | 1; // 是否单独展示0不展示、1展示
	showlocation?: number[];
	productSort?: number;
	shareImage?: string;
	shareInfo?: string;
}
@Component({
	components: {
		"app-hover-iocn-display": AppHoverIconDisplay,
	},
	mixins: [openAdStyle],
})
export default class AppHoverIcon extends Vue {
	data: ItemObject = {
		desc: {
			list: [],
			showBeforeIcon: ShouQi,
			showAfterIcon: ZhanKai,
		},
	};

	iconList = [];

	mounted() {
		this.getData();
	}

	getData(loading?) {
		IPSService.siteHoverIconInfo({
			postParams: {
				siteId: +this.$route.params.siteId,
			},
		}).then(
			(response) => {
				this.data = response;
				this.data.fieldType = "AppHoverIcon";
				!this.data.desc.showBeforeIcon && (this.data.desc.showBeforeIcon = ShouQi);
				!this.data.desc.showAfterIcon && (this.data.desc.showAfterIcon = ZhanKai);
				if (loading) {
					loading.close();
				}
			},
			() => {
				if (loading) {
					loading.close();
				}
			},
		);
	}

	onSave() {
		console.log("xuanfutubiao", this.data);
		const postParams = cloneDeep(this.data);
		let message = "";
		const iconImage = postParams.desc.list.some((v) => !v.iconImage || !v.iconImage.trim());
		const isCouponImage = postParams.desc.list.some((val) => val.linkType === 12 && !val.couponInfo.couponCover);
		const isCouponPoint = postParams.desc.list.some((val) => val.linkType === 12 && !val.couponInfo.points);
		if (iconImage) {
			message = "请上传图标";
			// @ts-expect-error
			this.$refs.form.$refs.AppHoverIcon.$refs.iconListForm.validate((result) => {
				if (!result) {
					this.$nextTick(() => {
						if (this.$el.querySelector(".is-error")) {
							this.$el.querySelector(".is-error").scrollIntoView({ behavior: "smooth", block: "center" });
						}
					});
				}
			});
		}
		if (isCouponPoint) {
			message = "请填写优惠券价格";
		}
		if (isCouponImage) {
			message = "请上传优惠券图片";
		}
		if (message) {
			// @ts-expect-error
			this.$refs.form.$refs.AppHoverIcon.$refs.linkForm.$refs.form.validate((result) => {
				if (!result) {
					this.$nextTick(() => {
						if (this.$el.querySelector(".is-error")) {
							this.$el.querySelector(".is-error").scrollIntoView({ behavior: "smooth", block: "center" });
						}
					});
				}
			});
			this.$message.warning(message);
			return;
		}
		postParams.fieldType = "HoverIcon";
		const loading = this.$loading({
			lock: true,
			text: "请稍等...",
			spinner: "el-icon-loading",
			background: "rgba(225,225,225,0.3)",
		});
		IPSService.siteHoverIconSave({
			postParams,
		}).then(
			(response) => {
				this.$message.success("保存成功");
				this.getData(loading);
			},
			() => {
				loading.close();
			},
		);
	}

	render(h) {
		return (
			<div style="height: 100%">
				<div class="body" style="height: calc(100% - 51px)">
					<div class="wid-198" style="border-right: 1px solid #eee;">
						<app-hover-iocn-display data={this.data.desc.list} openIcon={this.data.desc.showBeforeIcon} closeIcon={this.data.desc.showAfterIcon} isEnable={this.data.desc.isEnable} />
					</div>
					<div class="config">
						<section class="r-py-20" style="height: 100%;box-sizing: border-box;">
							<ShopDisplayEdit v-model={this.data} ref="form" />
						</section>
					</div>
				</div>
				<div class="bottomWrapper" style="border-top: 1px solid #eeeeee">
					<el-button type="primary" onClick={this.onSave.bind(this)}>
						保存
					</el-button>
				</div>
			</div>
		);
	}
}
